import React, { useState, useEffect } from "react";
import axios from "axios";
import  "./SalesEntryForm.css";
import { Colors } from "chart.js";
// import { toast } from 'react-toastify';
import { toast, cssTransition } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt, faUnderline } from "@fortawesome/free-solid-svg-icons";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import FloatingHelpButton from "./component/FloatingHelpButton"; // Adjust the path as necessary
import HelpModal from "./component/HelpModal"; // Ensure this import is correct
import AddHospitalModal from './component/AddHospitalModal'; 
import AddDoctorModal from './component/AddDoctorModal'; 
import PreviewForm from './component/PreviewForm'; 
import CongratulationModal from "./component/CongratulationModal";
import { maskMobileNumber, maskEmail} from "./utilities/maskfunction";
import VerticalStepper from './component/VerticalStepper';
import AddHospitalCityModal from "./component/AddHospitalCityModal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { formatDate } from "./utilities/formatDate";
// import congragulationPOPUP from './component/congragulationPOPUP';
const SalesEntryForm = () => {
  const [formData, setFormData] = useState({
    //Patient Section
    PatientSalutation: "",
    PatientFullName: "",
    PatientGender: "",
    PatientAge: "",
    PatientDateOfBirth: "",
    PatientMobileNumber: "",
    PatientEmailID: "",
    PatientHospitalID: "",
    PatientAddress: "",
    PatientCity: "",
    // PatientDetails: "",
    // UserID: '',

    //hospital Details section
    ReferringConsultantName_PrimaryPhysician: "",

    PrimaryPhysicianMobileNumber: "",
    PrimaryPhysicianEmailId: "",
    ReferringDoctorName_AlternatePhysician: "",
    AlternativePhysicianMobileNo: "",
    AlternativePhysicianEmailId: "",
    HospitalClinicName: "",
    HospitalorClinicalEmailId: "",
    City: "",
    ClinicalDetailsofPatient_PatientHistory_PriviousDiagonosis: "",
    //TestDetails

    SampleSent: "",
    NoOfSampleSent: "",
    tests: [{ test: "", sample: "" }],
    OtherTest: "",

    //Date & Signature

    SampleCollectionDate: "",
    SampleCollectionTime: "",
    SampleReceivedDate: "",
    ReportSendDate: "",
    FormFilledBy: "",
    FormFilledBy_Name: "",

    // Payment & Location details'',
    // TestDetails: '',
    // SampleCollectionDateTime: '',
    // FormFilledBy: '',
    // NameOfFormFiller: '',
    // SampleReceivedStatus: '',
    // ReceivedBy: '',
    // PaymentDetails: '',
    // Amount: ''

    // Payment section
    PaymentMethod: "",
    Amount: "",
    PickUpLocationType:"",
    Phelobotomist:"",
    PhelobotomistName:"",
    PickUpCity:"",
    PickUpAdress:"",
    PickUpCityPinCode:"",
    ContactPersonName:"",
    ContactPersonNumber:"",
    PickUpdate:"",


    PrimaryPhysicianMobileNumberEditable: "",
    PrimaryPhysicianEmailIdEditableEntry: "",
   


    // Current step
    currentStep: 1,
  });
  

  const resetForm = () => {
    setFormData({
      PatientSalutation: "",
      PatientFullName: "",
      PatientGender: "",
      PatientAge: "",
      PatientDateOfBirth: "",
      PatientMobileNumber: "",
      PatientEmailID: "",
      PatientHospitalID: "",
      PatientAddress: "",
      PatientCity: "",
      // PatientDetails: "",
      ReferringConsultantName_PrimaryPhysician: "",
      PrimaryPhysicianMobileNumber: "",
      PrimaryPhysicianEmailId: "",
      ReferringDoctorName_AlternatePhysician: "",
      AlternativePhysicianMobileNo: "",
      AlternativePhysicianEmailId: "",
      HospitalClinicName: "",
      HospitalorClinicalEmailId: "",
      City: "",
      ClinicalDetailsofPatient_PatientHistory_PriviousDiagonosis: "",
      SampleSent: "",
      NoOfSampleSent: "",
      tests: [{ test: "", sample: "" }],
      OtherTest: "",
      SampleCollectionDate: "",
      SampleCollectionTime: "",
      SampleReceivedDate: "",
      ReportSendDate: "",
      FormFilledBy: "",
      FormFilledBy_Name: "",
      PaymentMethod: "",
      Amount: "",
      Transaction_ID:"",
      PickUpLocationType:"",
      Phelobotomist:"",
      PhelobotomistName:"",
      PickUpCity:"",
    PickUpAdress:"",

    PickUpCityPinCode:"",
    ContactPersonName:"",
    ContactPersonNumber:"",
    PickUpdate:"",
      currentStep: 1,
    });
  };



  const [showInstructions, setShowInstructions] = useState(true);
  const [isAgreed, setIsAgreed] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [cities, setCities] = useState([]);
  const [hospitals, setHospitals] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [showAddHospitalModal, setShowAddHospitalModal] = useState(false);
  const [showAddDoctorModal, setShowAddDoctorModal] = useState(false);
  const [selectedCityId, setSelectedCityId] = useState(null);
  const [selectedHospitalId,seSelectedHospitalId]=useState(null);
  const [showCongratsModal, setShowCongratsModal] = useState(false);
  const [testlist, settestlist]=useState([]);
  const [loading, setLoading] = useState(false);
  const [amountText, setAmountText] = useState("");
  const [showAddCityModal, setShowAddCityModal]=useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [OriginalEmail,setOriginalEmail]=useState([])
  const [phlebotomists, setPhlebotomists] = useState([]);

  // Fetch active phlebotomists for the TRF Pick-Up dropdown
  useEffect(() => {
    const fetchPhlebotomists = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/phlebotomists`);
        setPhlebotomists(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Failed to fetch phlebotomists:", error);
      }
    };
    fetchPhlebotomists();
  }, []);

  //get cities

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/cities`);
        setCities(response.data);
        
      } catch (error) {
        console.error("Failed to fetch cities:", error);
      }
    };
    fetchCities();
  }, []);

  //get hospitals based on city selected

  let cityid;
  useEffect(() => {
    console.log("Updated value of showAddDoctorModal (in useEffect):", showAddDoctorModal);
  }, [showAddDoctorModal]);
  useEffect(() => {
    const fetchHospitals = async () => {
      if (formData.City) {
        for (let a of cities) {
          if (a.name === formData.City) {
            cityid = a.id;
            console.log("cityid", cityid);
            setSelectedCityId(cityid)
          }
        }
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/hospitals/${cityid}`
          );
          setHospitals(response.data);
          console.log("hospitallist", response.data);
          setDoctors([]);// clear the doctors data when hospital name is selected
        } catch (error) {
          console.error("Failed to fetch hospitals:", error);
          toast.error("Failed to fetch hospitals");
        }
      } else {
        setHospitals([]);
      }
    };

    fetchHospitals();
  }, [formData.City]);

  //fetch doctors details based on hospital id
  let hospitalid;
  useEffect(() => {
    if (formData.HospitalClinicName) {
      console.log("hospitalslist", hospitals);
      console.log("formData.HospitalClinicName", formData.HospitalClinicName);

      for (let a of hospitals) {
        if (a.hospitalName === formData.HospitalClinicName) {
          hospitalid = a.id;
          console.log("hopsitalid", hospitalid);
          seSelectedHospitalId(hospitalid);
        }
      }
      const fetchDoctors = async () => {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/doctors/${hospitalid}`
          );
          setDoctors(response.data);
          console.log("doctors list", doctors);
        } catch (error) {
          console.error("Failed to fetch doctors:", error);
        }
      };
      fetchDoctors();
    } else {
      setDoctors([]);
    }
  }, [formData.HospitalClinicName]);


  useEffect(()=>{

    const fetchtestlist=async()=>{
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/testlist`
      );
      const sortedList = response.data.sort((a, b) => a.TestName.localeCompare(b.TestName));
      settestlist(sortedList);
      console.log("testlist", sortedList);
    } catch (error) {
      console.error("Failed to fetch Testlist:", error);
      toast.error("Failed to fetch Testlist");
    }
  //  else {
  //   settestlist([]);
  // }

}
fetchtestlist();
  },[formData.tests.test]);

  //setMobNumber
  // useEffect(() => {
  //   const fetchMobNumber = async () => {
  //     if (formData.ReferringConsultantName_PrimaryPhysician)
  //       {
  //         try {
  //           const selectedDoctor = doctors.find((doctor) => doctor.doctorName === formData.ReferringConsultantName_PrimaryPhysician)
  //             const PrimaryPhysicianMobileNumber= selectedDoctor ? maskMobileNumber(selectedDoctor.mobile_number): "";
  //             setMobNumber(PrimaryPhysicianMobileNumber);
  //             } 
  //         catch (error){
  //         console.error("Failed to Mobile number:", error);
  //         }
  //       } 
  //     else 
  //       {
  //         setMobNumber([]);
  //       }
  //   };
  //   fetchMobNumber();
  // }, [formData.ReferringConsultantName_PrimaryPhysician]);



  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "Amount") {
      setAmountText(convertAmountToText(value));
    }

    if(name === "SampleCollectionDate" && value > getTodayDate()){
      alert("Date cannot be grater than today")
    return
    }

    if(name==="NoOfSampleSent" && value<0){
      toast.error("Verify Number of samples Sent")
      
      }
   
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle Pick-Up location source selection in Step 5.
  // "hospital" -> auto-fill pickup fields from the selected hospital's location.
  // "phlebotomist" -> show phlebotomist dropdown; fields fill once one is chosen.
  const handlePickUpLocationChange = (e) => {
    const value = e.target.value;

    if (value === "hospital") {
      const selectedHospital = hospitals.find(
        (h) => h.hospitalName === formData.HospitalClinicName
      );
      setFormData((prevState) => ({
        ...prevState,
        PickUpLocationType: value,
        Phelobotomist: "",
        PhelobotomistName: "",
        PickUpCity:
          selectedHospital?.hospitalCity ||
          selectedHospital?.hospital_city ||
          prevState.City ||
          "",
        PickUpAdress:
          selectedHospital?.hospitalAddress ||
          selectedHospital?.hospital_address ||
          "",
        PickUpCityPinCode:
          selectedHospital?.hospitalPincode ||
          selectedHospital?.hospital_pincode ||
          "",
      }));
    } else {
      // Phlebotomist location or no selection: clear for fresh entry / selection.
      setFormData((prevState) => ({
        ...prevState,
        PickUpLocationType: value,
        Phelobotomist: "",
        PhelobotomistName: "",
        PickUpCity: "",
        PickUpAdress: "",
        PickUpCityPinCode: "",
      }));
    }
  };

  // When a phlebotomist is picked, auto-fill the Pick-Up fields from their record.
  // Fields remain editable afterwards.
  const handlePhlebotomistSelect = (e) => {
    const id = e.target.value;
    const p = phlebotomists.find((x) => String(x.id) === String(id));
    if (!p) {
      // Cleared selection
      setFormData((prevState) => ({
        ...prevState,
        Phelobotomist: "",
        PhelobotomistName: "",
      }));
      return;
    }
    setFormData((prevState) => ({
      ...prevState,
      Phelobotomist: p.id,
      PhelobotomistName: p.name,
      PickUpAdress: p.address || "",
      PickUpCity: p.city || "",
      PickUpCityPinCode: p.pincode || "",
      ContactPersonName: p.name || prevState.ContactPersonName,
      ContactPersonNumber: p.mobile_number || prevState.ContactPersonNumber,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Show loader when request starts
    const ReferringDoctorName_AlternatePhysician=`Dr.${formData.ReferringDoctorName_AlternatePhysician}`
    const formDataToSubmit = {
      ...formData,
      PatientFullName: `${formData.PatientSalutation} ${formData.PatientFullName}`,
      
      ReferringDoctorName_AlternatePhysician:`${ReferringDoctorName_AlternatePhysician}`?`${ReferringDoctorName_AlternatePhysician}`:"",

      PrimaryPhysicianEmailId: OriginalEmail || formData.PrimaryPhysicianEmailId
      
    
    };
    console.log("formDataToSubmit",formDataToSubmit)
    try {
      const response = await axios.post(
        
        `${process.env.REACT_APP_API_BASE_URL}/api/sales/sales-entry`,
        formDataToSubmit
      );

      alert("Details Entered is saved successfully!");
      toast.success("Details Entered is saved successfully!");

      console.log(response.data); // Log the new sales entry
      

     
      setShowCongratsModal(true);

      try {

       
        // send email URL
        console.log("salesEmailNotification",formDataToSubmit.PatientFullName, formDataToSubmit.City);
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/sales/notificationEmail`,{
          patienfullname:formDataToSubmit.PatientFullName,
          hospitalcity:formDataToSubmit.City });
       
      
     
        } catch (emailError) {
          console.error('Failed to send notification email:', emailError);
          const errorMessage = emailError.response?.data?.error || "Failed to send notification email. Please try again later.";
          toast.error(errorMessage);
        }
    } catch (createError) {
      console.error("Failed to create sales entry:", createError);
      const errorMessage = createError.response?.data?.error || "Failed to create sales entry. Please check your input or try again.";
  alert("Failed to create sales entry.");
  toast.error("Failed to create sales entry. Please check your input or try again.");
  toast.error(errorMessage);
     
     
    }
    setLoading(false); // Hide loader when request completes
  };

  const handleNext = (e) => {

    //scroll page to top
  
    window.scrollTo(0, 0);
    const { 
      PrimaryPhysicianMobileNumberEditable, 
      PrimaryPhysicianEmailIdEditableEntry, 
      ...formDataToValidate 
    } = formData;
    console.log("formadata to validate",formDataToValidate)

   
    // Determine if the current step's fields are valid
    const isValid = validateCurrentStep(formDataToValidate, formDataToValidate.currentStep);
    console.log("isValid",isValid)
    if(formData.PatientSalutation===""){
      toast.error("Please fill Patient Salutation")
      return
    }
    if(formData.PatientFullName===""){
      toast.error("Please fill Patient Name")
      return
    }
    if(formData.PatientGender===""){
      toast.error("Please select Patient Gender")
      return
    }
    if(formData.PatientAge===""){
      toast.error("Please fill Patient Age")
      return
    }
    if (formData.PatientMobileNumber && !/^\d{10}$/.test(formData.PatientMobileNumber)) {
      toast.error("Mobile number must be exactly 10 digits.");
      return;
    }
    if(formData.PatientEmailID){
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailPattern.test(formData.PatientEmailID)) {
        toast.error("Please enter a valid email address.");
        return;
      }
    }
    if(formData.PatientCity===""){
      toast.error("Please fill Patient City");
      return
    }

   

    if(formData.currentStep==2 && formData.City===""){
      toast.error("Please Select the Hospital City");
      return
    }
    if(formData.currentStep==2 && formData.HospitalClinicName===""){
      toast.error("Please Select the Hospital");
      return
    }
    if(formData.currentStep==2 && formData.ReferringConsultantName_PrimaryPhysician===""){
      toast.error("Please Select the Primary/Referring  Doctor");
      return
    }

    if(formData.currentStep==2 && formData.AlternativePhysicianMobileNo && !/^\d{10}$/.test(formData.AlternativePhysicianMobileNo)){
      toast.error("Alternative Physician Mobile No must be 10 digit")
    }
    if(formData.currentStep==2 && formData.AlternativePhysicianEmailId) {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailPattern.test(formData.AlternativePhysicianEmailId)) {
        toast.error("Please enter a valid email address.");
        return;
      }
      
    }
    if(formData.currentStep==2 && formData.HospitalorClinicalEmailId) {
      console.log("into step 2-HospitalorClinicalEmailId")
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailPattern.test(formData.HospitalorClinicalEmailId)) {
        toast.error("Please enter a valid Hospital email address.");
        return;
      }
      
    }
    if(formData.currentStep==3 && formData.SampleSent===""){
      console.log("into step 3")
      toast.error("Please select type of sample sent");
      return
    }
    if(formData.currentStep==3 && formData.NoOfSampleSent===""){
      toast.error("Please select No. of sample sent");
      return
    }
    if(formData.currentStep==4 && formData.SampleCollectionDate===""){
      toast.error("Please fill Sample Collection Date");
      return
    }
    if(formData.currentStep==4 && formData.SampleCollectionTime===""){
      toast.error("Please fill Sample Collection time");
      return
    }
    if(formData.currentStep==4 && formData.FormFilledBy===""){
      toast.error("Please fill Form filled by");
      return
    }
     if(formData.currentStep==4 && formData.FormFilledBy_Name===""){
      toast.error("Please fill Form filled by Name field");
      return
    }
    // if(formData.currentStep==5 && formData.PaymentMethod===""){     //srini told its not mandatory this on 27 nov 2024
    //   toast.error("Please select Payment Method");
    //   return
    // }
    // if(formData.currentStep==5 && formData.Amount===""){
    //   toast.error("Please fill the amount to be payable");
    //   return
    // }
  
    if(formData.currentStep==5 && formData.ContactPersonNumber && !/^\d{10}$/.test(formData.ContactPersonNumber)){
      toast.error("Mobile number should be 10 digit");
      return
    }

    

  
    

    if (isValid) {
      // Only increment currentStep if the current form data is valid
      setFormData((prevState) => ({
        ...prevState,
        currentStep: prevState.currentStep + 1,
      }));
      toast.success("Details Saved Successfully", {
        position: "bottom-right",
      });
    } else {
      alert("Please fill in all required fields.");
      toast.error("Please fill in all required fields", {
        position: "bottom-right",
        autoClose: 8000,
      });
    }
  };

  const handleBack = () => {
    // Decrement currentStep if not the first step
    setFormData((prevState) => ({
      ...prevState,
      currentStep: prevState.currentStep - 1,
     
    }));
    window.scrollTo(0, 0);
  };

  // Validation function to check required fields based on the current step
  
  function validateCurrentStep(formData, currentStep) {
    console.log("formData.Test:", formData);
    switch (currentStep) {
      case 1: // Validate first step fields
     
        return (
          
          formData?.PatientSalutation?.trim() !== "" &&
          formData?.PatientFullName?.trim() !== "" &&
          formData?.PatientGender?.trim() !== "" &&
          formData?.PatientAge?.toString().trim() !== ""&&
          formData?.PatientCity?.trim()!==""
        );

      case 2: // Validate second step fields
        return (
         
          formData?.ReferringConsultantName_PrimaryPhysician?.trim() !== "" &&
          formData?.HospitalClinicName?.trim() !== "" &&
          formData?.City?.trim() !== ""
        );
        case 3: // Validate third step fields
        return (
          formData.SampleSent?.trim() !== "" &&
          formData.NoOfSampleSent?.trim()>0 &&
          formData.tests[0].test?.trim()!=="" &&
          formData.tests[0].sample?.trim()!==""
        );
      case 4: // Validate fourth step fields 
        return (
          formData.SampleCollectionDate.trim() !== "" 
        );
        case 5: // Validate fifth step fields 
        return true;
        // return (
        //   formData.PaymentMethod.trim() !== "" && formData.Amount.trim() !== ""      
        // );                                                          // srini told these fields are not mandatory on 27 nov 2024
      default:
        return false;
    }
  }

  const handleTestChange = (index, field, value) => {
    const updatedTests = formData.tests.map((test, i) => {
      if (i === index) {
        return { ...test, [field]: value };
      }
      return test;
    });
    setFormData({ ...formData, tests: updatedTests });
  };

  const addTest = () => {
    setFormData({
      ...formData,
      tests: [...formData.tests, { test: "", sample: "" }],
    });
  };

  const removeTest = (index) => {
    setFormData({
      ...formData,
      tests: formData.tests.filter((_, i) => i !== index),
    });
  };
  // const [ageerrorMessage, setageErrorMessage] = useState('');
  const calculateAge = (dob) => {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  const handleDOBChange = (e) => {
    const { value } = e.target;
    const calculatedAge = calculateAge(value);
    setFormData((prevState) => ({
      ...prevState,
      PatientDateOfBirth: value,
      PatientAge: calculatedAge, // Update the age based on DOB
    }));

    if (formData.PatientAge && formData.PatientAge !== calculatedAge) {
      {
        toast.warning(
          "The entered age does not match the calculated age based on the date of birth, hence the calculated age will be considered."
        );
        alert(`Age considered is ${calculatedAge}`);
      }
      setTimeout(() => {
        toast.success("Date of birth and age matches");
      }, 2000); // 2000 milliseconds = 2 seconds
    }
  };
  const handleAgreementChange = (e) => {
    setIsAgreed(e.target.checked);
  };

  const handleAgreementSubmit = (e) => {
    e.preventDefault();
    if (isAgreed) {
      setShowInstructions(false);
    } else {
      toast.error("You must agree to the terms to proceed.");
    }
  };
  const getTodayDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };
   // Convert amount to text
   

    // Function to convert amount to text
    const convertAmountToText = (amount) => {
      if (!amount) return "";
      const numberToWords = (n) => {
        const singleDigits = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
        const doubleDigits = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
        const tensMultiple = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
        const placeValues = ["", "Thousand", "Lakh", "Crore"];
    
        let words = [];
        let unitIndex = 0;
    
        // Function to handle three-digit chunks
        const convertThreeDigits = (num) => {
          let chunk = [];
          if (num > 99) {
            chunk.push(singleDigits[Math.floor(num / 100)] + " Hundred");
            num %= 100;
          }
          if (num > 19) {
            chunk.push(tensMultiple[Math.floor(num / 10)]);
            num %= 10;
          }
          if (num > 9 && num < 20) {
            chunk.push(doubleDigits[num - 10]);
          } else if (num > 0) {
            chunk.push(singleDigits[num]);
          }
          return chunk.join(" ");
        };
    
        // Break the amount into groups of thousands
        while (amount > 0) {
          let part = amount % 1000;
          if (part > 0) {
            words.unshift(convertThreeDigits(part) + " " + placeValues[unitIndex]);
          }
          amount = Math.floor(amount / 1000);
          unitIndex++;
        }
    
        return words.join(" ").trim();
      };
    
      return numberToWords(parseInt(amount.replace(/,/g, ""), 10));
    };
    const formatDateToISO = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0"); // months are 0-based
  const day = String(d.getDate()).padStart(2, "0");
  console.log("format date",`${year}-${month}-${day}`)
  return `${year}-${month}-${day}`;
};

    const handleDOBChangeCustom = (date, fieldName) => {
       const value = formatDateToISO(date);
       console.log("value of birth",value)
   
      const calculatedAge = calculateAge(value);
  setFormData((prevData) => ({
    ...prevData,
       PatientDateOfBirth: value,
      PatientAge: calculatedAge, // Update the age based on DOB
    // [fieldName]: value, // or format it as string if needed
  }));
   if (formData.PatientAge && formData.PatientAge !== calculatedAge) {
    toast.warning(
      "The entered age does not match the calculated age based on the date of birth, hence the calculated age will be considered."
    );
    alert(`Age considered is ${calculatedAge}`);

    setTimeout(() => {
      toast.success("Date of birth and age matches");
    }, 2000);
  }
};
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
 

  return (
    <>
      <ToastContainer position="bottom-right" autoClose={5000} />
      <title>ZeinixSalesForm</title>
      <div className="header" >
        <div className="imagePosition">
           <img src="data:image/png;base64,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" alt="ZeiniX"></img>
        </div>
        <div className="headerContent">
          <h1>Autoimmune Neurology Diagnostics</h1>
          <h2>Test Request Entry Form</h2>
        </div>

      </div>
      {loading && <div className="loader"></div>}
      <div style={{ paddingTop: "0px" }}>
        {showInstructions ? (
          <div className="instructions-container">
            <div style={{ backgroundColor: "whitesmoke" }}>
              <h2 style={{ textDecoration: 'underline' }}>Important Instructions and Disclaimer</h2>
              <h4 style={{ marginBottom: "0px", textAlign: 'left', paddingLeft: '20px' }}>Sample Sent Through ZeiniX Life Sciences</h4>
              <p style={{ fontWeight: "inherit", fontSize: '15px', margin: '0px', textAlign: 'left', paddingLeft: '20px' }}>(Tested At: Nalanda 7th Floor, Amrita Institute of Medical Sciences & Research Centre (AIMS), Kochi, Kerala,  India)</p>
            </div>


            <p style={{ textAlign: "left", marginLeft: '30px', fontStyle: "italic" }}>
              Please read the following instructions and disclaimer carefully before proceeding with the form.
            </p>

            <ul style={{ textAlign: "left", listStyle: 'square',marginLeft:"15px" }}>
              <li>Please enter patient name exactly as needed in the report / invoice.  </li>
              <li>Form Once submitted, name cannot be changed.</li>
              <li>Please ensure the name in this TRF & sample tube are exactly same - otherwise sample will get rejected</li>
            </ul>
            <form onSubmit={handleAgreementSubmit}>
              <label style={{ display: "flex", marginLeft: '20px' }}>
                <input
                  type="checkbox"
                  checked={isAgreed}
                  onChange={handleAgreementChange}
                  style={{ marginRight: '13px', color: "black", width: '16px', height: '16px' }} />
                I have read and agree to the terms and conditions.
              </label>
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px', marginBottom:'10px' }}>
                <button className={`agreementbutton ${isAgreed ? 'isAgreed' : ''}`} type="submit" disabled={!isAgreed}>

                  Proceed
                </button>
              </div>
            </form>
          </div>
        ) :
          (
            <>
              <div className="sales-form-container" style={{ paddingTop: "0px"}}>

                <VerticalStepper currentStep={formData.currentStep} />
                <form onSubmit={handleSubmit}>
                  {/* Render form sections based on the current step */}

                  {formData.currentStep === 1 && (
                    <>
                    
                    
                      <div style={{ backgroundColor: "blue", marginTop: "115px", borderRadius :"8px", color:"whitesmoke"}}>
                        <h2 style={{ marginTop: "0px", justifyItems: "center" }}>
                          Patient Details
                        </h2>
                      </div>
                      <div>
  {/* Patient Details section */}
  {[
    "PatientSalutation",
    "PatientFullName",
    "PatientGender",
    "PatientAge",
    "PatientDateOfBirth",
    "PatientMobileNumber",
    "PatientEmailID",
    "PatientHospitalID",
    "PatientAddress",
    "PatientCity",
  ].map((field) => (
    <div key={field}>
      {field === "PatientEmailID" ? (
        // Custom label for PatientEmailID
        <>
          <label className="sales-form-label">
            Patient Email Id: 
          </label>
          <input
            type="email"
            name={field}
            value={formData[field]}
            onChange={handleChange}
            className="sales-form-input"
           
          />
        </>
      ) : field === "PatientHospitalID"?
      (
        <>
         <label className="sales-form-label">
            Patient Hospital Id: 
          </label>
          <input
            type="email"
            name={field}
            value={formData[field]}
            onChange={handleChange}
            className="sales-form-input"
            
          />
        
        </>
      ):
      
      (
        <>
          <label className="sales-form-label">
            {field.replace(/([A-Z])/g, " $1").trim()}:
            {[
              "PatientSalutation",
              "PatientFullName",
              "PatientGender",
              "PatientAge",
              // "PatientDateOfBirth",
              // "PatientMobileNumber",
              // "PatientAddress",
              "PatientCity",
            ].includes(field) && <span className="required">*</span>}
          </label>
          {field === "PatientSalutation" ? (
            <select
              type="text"
              name={field}
              value={formData[field]}
              onChange={handleChange}
              required
              className="sales-form-input"
            >
              <option value="">Select Salutation</option>
              <option value="Mr.">Mr.</option>
              <option value="Mrs.">Mrs.</option>
              <option value="Miss">Miss</option>
              <option value="Dr.">Dr.</option>
              <option value="Prof.">Prof.</option>
              <option value="Master">Master.</option>
            </select>
          ) : field === "PatientFullName" ? (
            <input
              type="name"
              name={field}
              value={formData[field]}
              onChange={handleChange}
              className="sales-form-input"
              required
            />
          ) : field === "PatientGender" ? (
            <select
              type="text"
              name={field}
              value={formData[field]}
              onChange={handleChange}
              required
              className="sales-form-input"
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          ) : field === "PatientAge" ? (
            <div>
              <input
                type="number"
                name={field}
                value={formData[field]}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value > 100) {
                    e.target.value = "";
                    toast.error("Age cannot be more than 100");
                  } else if (value % 1 !== 0) {
                    e.target.value = Math.floor(value); // Ensure the value is an integer
                    toast.error("Age must be a whole number");
                  } else {
                    handleChange(e);
                  }
                }}
                className="sales-form-input"
                min="0" // Minimum value
                max="100"
                required
              ></input>
            </div>
            ) : field === "PatientDateOfBirth" ? (
               isSafari ? (
    <DatePicker
      selected={formData[field]}
      onChange={(date) => handleDOBChangeCustom(date, field)}
      className="sales-form-input"
      dateFormat="dd-MMM-yyyy"
      maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 5))}
      showYearDropdown
      scrollableYearDropdown   
      showMonthDropdown
      yearDropdownItemNumber={90}
    />
  ) : (
    <input
      type="date"
      name={field}
      value={formData[field] }
      onChange={handleDOBChange}
      className="sales-form-input"
      // max={new Date(new Date().setFullYear(new Date().getFullYear() + 5))
      //   .toISOString()
      //   .split("T")[0]}
    />)
            ) : field === "PatientMobileNumber" ? (
            <input
              type="number"
              name={field}
              value={formData[field]}
              onChange={handleChange}
              className="sales-form-input"
              min="0"
              max="9999999999"
            />
          ) : (
            <input
              type="text"
              name={field}
              value={formData[field]}
              onChange={handleChange}
              className="sales-form-input"
              required
            />
          )}
        </>
      )}
    </div>
  ))}
</div>
                    </>
                  )}
                  {formData.currentStep === 2 && (
                    <>
                      <div style={{ backgroundColor: "blue", marginTop: "115px" , borderRadius :"8px"}}>
                        <h2 style={{ marginTop: "0px", justifyItems: "center", color:"whitesmoke"}}>
                          Doctor & Hospital Details
                        </h2>
                      </div>
                      <div>
                        {/* Hospital Details section */}
                        <label className="sales-form-label">Hospital City: <span style={{ color: 'red' }}>*</span></label>
                        <select
                          name="City"
                          value={formData.City}
                          onChange={(e)=>{
                            if(e.target.value==='add_new_hospital_city'){
                              setShowAddCityModal(true);
                            }
                            else{
                              handleChange(e)
                            }
                          }}
                          // onChange={handleChange}
                          className="sales-form-input"
                          // required
                        >
                          <option value="">Select City</option>
                          {cities.map((City) => (
                            <option key={City.id} value={City.name}>
                              {City.name}
                            </option>
                          ))}
                          {/* <option value="add_new_hospital_city">Add New City</option> */} 
                        </select>
                        <label className="sales-form-label">
                          Hospital / Clinic Name: <span style={{ color: 'red' }}>*</span>
                        </label>
                        <select
                          name="HospitalClinicName"
                          value={formData.HospitalClinicName}
                          onChange={(e) => {
                            if (e.target.value === "add_new_hospital") {
                              setShowAddHospitalModal(true);
                            } else {
                              handleChange(e);
                            }
                          } }
                          className="sales-form-input"
                        >
                          <option value="">Select Hospital or Clinic Name</option>
                          {hospitals.map((hospital) => (
                            <option key={hospital.id} value={hospital.hospitalName}>
                              {hospital.hospitalName}

                            </option>

                          ))};
                          {/* {formData.City && <option value="add_new_hospital">Add New Hospital</option>} */}

                        </select>
                        {/* <button type="button" onClick={() => setShowAddHospitalModal(true)}>Add New Hospital</button> */}
                        <label className="sales-form-label">
                          Referring Consultant Name (Primary Physician): <span style={{ color: 'red' }}>*</span>
                        </label>
                        
                        <select
                          name="ReferringConsultantName_PrimaryPhysician"
                          value={formData.ReferringConsultantName_PrimaryPhysician}
                          // onChange={handleChange}
                          onChange={(e) => {
                            if (e.target.value === "add_new_doctor") {
                              console.log("setShowAddDoctorModal:", typeof setShowAddDoctorModal);
                              console.log("step 1:", showAddDoctorModal);
                              setShowAddDoctorModal(true);
                              console.log("step 2 after:", showAddDoctorModal)
                            } else {
                              const selectedDoctor = doctors.find(
                                (doctor) => doctor.doctorName === e.target.value
                              );
                              console.log("step 2")
                              console.log("selectedDoctor", selectedDoctor);
                              setFormData({
                                ...formData,
                                ReferringConsultantName_PrimaryPhysician: selectedDoctor
                                  ? selectedDoctor.doctorName
                                  : "",
                                PrimaryPhysicianMobileNumber: selectedDoctor
                                  ? maskMobileNumber(selectedDoctor.mobile_number)
                                  : "",
                                  PrimaryPhysicianMobileNumberEditable: !selectedDoctor?.mobile_number,
                                
                                PrimaryPhysicianEmailId: selectedDoctor ? maskEmail(selectedDoctor.email) : "",
                                PrimaryPhysicianEmailIdEditableEntry: !selectedDoctor ?.email
                              });
                              setOriginalEmail(selectedDoctor?.email || "");
                              // {console.log("selected doctor",selectedDoctor,selectedDoctor?.mobile_number,PrimaryPhysicianMobileNumberEditable)}
                            }
                          } }
                          className="sales-form-input"
                          // required
                        >

                          <option value="">Select Referring Doctor or Primary Physician Name</option>
                          {doctors.map((doctor) => (
                            <option key={doctor.id} value={doctor.doctorName}> {doctor.doctorName}</option>

                          ))}
                          {/* <option value="add_new_doctor">Add New Doctor</option> */}
                        </select>



                        <label className="sales-form-label">
                          Primary Physician Mobile Number:
                        </label>
                        {/* {console.log("PrimaryPhysicianMobileNumberEditable",PrimaryPhysicianMobileNumberEditable)} */}
                        <input
                          type="text"
                          name="PrimaryPhysicianMobileNumber"
                          value={formData.PrimaryPhysicianMobileNumber}
                          onChange={handleChange}
                          className="sales-form-input"
                          readOnly={!formData.PrimaryPhysicianMobileNumberEditable}
                          
                          />
                        <label className="sales-form-label">
                          Primary Physician Email Id:
                        </label>
                        <input
                          type="text"
                          name="PrimaryPhysicianEmailId"
                          value={formData.PrimaryPhysicianEmailId}
                          onChange={handleChange}
                          className="sales-form-input"
                          readOnly={!formData.PrimaryPhysicianEmailIdEditableEntry} />
                        <label className="sales-form-label">
                          Referring Doctor Name (Alternate Physician):
                        </label>
                        <div style={{display:"flex",alignItems:"center"}}>
                        <span >Dr.</span>
                        <input
                          type="text"
                          name="ReferringDoctorName_AlternatePhysician"
                          value={formData.ReferringDoctorName_AlternatePhysician}
                          onChange={handleChange}
                          className="sales-form-input" />
                          </div>
                        <label className="sales-form-label">
                          Alternative Physician Mobile Number:
                        </label>
                        <input
                          type="text"
                          name="AlternativePhysicianMobileNo"
                          value={formData.AlternativePhysicianMobileNo}
                          onChange={handleChange}
                          className="sales-form-input" />
                        <label className="sales-form-label">
                          Alternative Physician Email Id:
                        </label>
                        <input
                          type="text"
                          name="AlternativePhysicianEmailId"
                          value={formData.AlternativePhysicianEmailId}
                          onChange={handleChange}
                          className="sales-form-input" />

                        <label className="sales-form-label">
                        Hospital / Lab / Clinic Email Id:
                        </label>
                        <input
                          type="text"
                          name="HospitalorClinicalEmailId"
                          value={formData.HospitalorClinicalEmailId}
                          onChange={handleChange}
                          className="sales-form-input" />

                        <label className="sales-form-label">
                          Clinical Details of Patient / Patient History / Previous
                          Diagonosis:
                        </label>
                        <input
                          type="text"
                          name="ClinicalDetailsofPatient_PatientHistory_PriviousDiagonosis"
                          value={formData.ClinicalDetailsofPatient_PatientHistory_PriviousDiagonosis}
                          onChange={handleChange}
                          className="sales-form-input" />

                        {/* Add more hospital fields as needed */}
                      </div>
                    </>
                  )}
                  {formData.currentStep === 3 && (
                    <>
                      <div
                        style={{
                          backgroundColor: "blue",
                          marginTop: "0px",
                          textAlign: "center",
                           borderRadius :"8px"
                        }}
                      >
                        <h2 style={{ marginTop: "115px" ,color:"whitesmoke"}}>Test Details</h2>
                      </div>
                      <div>
                        {/* Sample Sent Input */}
                        <label className="sales-form-label">Sample Sent: <span style={{ color: 'red' }}>*</span></label>
                        <select
                          type="text"
                          name="SampleSent"
                          value={formData.SampleSent}
                          onChange={handleChange}
                          className="sales-form-input"
                          required
                        >
                          <option value="">Select Sample</option>
                          <option value="Serum">Serum</option>
                          <option value="CSF">CSF</option>
                          <option value="Both Serum & CSF">Both Serum & CSF</option>
                        </select>



                        {/* Number of Samples Sent Input */}
                        <label className="sales-form-label">
                          Number of Samples Sent: <span style={{ color: 'red' }}>*</span>
                        </label>
                        <select
                        type="number"
                        name="NoOfSampleSent"
                        value={formData.NoOfSampleSent}
                        onChange={handleChange}
                        className="sales-form-input" 
                        required
                        >
                          <option value="">Select</option>
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>

                        </select>
                       
                      </div>
                      <div style={{ marginBottom: "10px", position: "relative" }}>
                        {formData.tests.map((test, index) => (
                          <div key={index} className="test-and-sample-container">
                            <label className="sales-form-label">
                              Test {index + 1} : <span style={{ color: 'red' }}>*</span>
                            </label>
                            <select
                              type="text"
                              name={`test${index + 1}`}
                              value={test.test}
                              onChange={(e) => handleTestChange(index, "test", e.target.value)}
                              className="sales-form-input">


                              <option value="">Select Test </option>
                              {testlist.map((test) => (
                            <option key={test.id} value={test.TestName}>
                              {test.TestName}
                            </option>
                          ))}
                              
                            </select>
                           

                            <label className="sales-form-label">
                              Sample for Test {index + 1}:
                            </label>
                            <select
                              type="text"
                              name={`SampleForTest${index + 1}`}
                              value={test.sample}
                              onChange={(e) => handleTestChange(index, "sample", e.target.value)}
                              className="sales-form-input">
                                
                              <option value="">Select Sample</option>
                              {test.test==="CNS Inflammation Extended" || test.test==="Autoimmune Dementia Evaluation Panel Optimised (Both Serum & CSF)"||test.test==="Multiple Sclerosis"? ( <option value="Both Serum & CSF">Both Serum & CSF</option>):(
                                <>
                              <option value="Serum">Serum</option>
                              <option value="CSF">CSF</option>
                              </>)}
                              {/* <option value="Both Serum & CSF">Both Serum & CSF</option> */}
                            </select>

                            {index > 0 && (
                              <button
                                type="button"
                                onClick={() => removeTest(index)}
                                className="removetest-button"
                                title="Delete"
                              >
                                <FontAwesomeIcon icon={faTrashAlt} />
                              </button>
                            )}
                          </div>
                        ))}
                        <button
                          type="button"
                          onClick={addTest}
                          className="addtest-button"
                          title="Add test"
                        >
                          {" "}
                          Add New Test
                          <FontAwesomeIcon icon={faCirclePlus} />
                        </button>
                      </div>
                    </>
                  )}

                  {formData.currentStep === 4 && (
                    <>
                      <div
                        style={{
                          backgroundColor: "blue",
                          marginTop: "0px",
                          textAlign: "center",
                           borderRadius :"8px"
                        }}
                      >
                        <h2 style={{ marginTop: "115px", color:"whitesmoke" }}>Sample Collection Details </h2>
                      </div>
                      <div>
                        {/* Sample Collection Date Input */}
                        <label className="sales-form-label">
                          Sample Collection Date: <span style={{ color: 'red' }}>*</span>
                        </label>
                        <input
                          type="date"
                          name="SampleCollectionDate"
                          value={formData.SampleCollectionDate}

                          onChange={handleChange}
                          className="sales-form-input"
                          max={getTodayDate()}
                          required />

                        {/* Sample Collection Time Input */}
                        <label className="sales-form-label">
                          Sample Collection Time: <span style={{ color: 'red' }}>*</span>
                        </label>
                        <input
                          type="time"
                          name="SampleCollectionTime"
                          value={formData.SampleCollectionTime}
                          onChange={handleChange}
                          className="sales-form-input"
                          required />

                        {/* Form Filled By Input */}
                        <label className="sales-form-label">Form Filled By: <span style={{ color: 'red' }}>*</span></label>
                        <select
                          type="text"
                          name="FormFilledBy"
                          value={formData.FormFilledBy}
                          onChange={handleChange}
                          className="sales-form-input"
                          required>
                          <option value="">Select Form Filled by</option>
                          <option value="Referring Dr / Alternate Physician">Referring Dr / Alternate Physician</option>
                          <option value="Lab-In-Charge">Lab-In-Charge</option>
                          <option value="Patient's Relative / Patient">Patient's Relative / Patient</option>
                        </select>

                        <label className="sales-form-label">Form Filled By (Name)<span style={{ color: 'red' }}>*</span></label>
                        <input
                          type="text"
                          name="FormFilledBy_Name"
                          value={formData.FormFilledBy_Name}
                          onChangeCapture={handleChange}
                          className="sales-form-input"
                          required />

                        {/* Additional fields and logic for other inputs */}
                      </div>
                    </>
                  )}

                  {formData.currentStep === 5 && (
                    <>
                      <div style={{ backgroundColor: "blue", marginTop: "115px", borderRadius :"8px" }}>
                        <h2 style={{ marginTop: "0px", justifyItems: "center" , color:"whitesmoke"}}>
                          Payment & Location details 
                        </h2>
                      </div>
                      <div>
                        {/* Payment Details section */}
                        <label className="sales-form-label">Payment Method:  </label>
                        <select
                          type="text"
                          name="PaymentMethod"
                          value={formData.PaymentMethod}
                          onChange={handleChange}
                          className="sales-form-input">
                          <option value="">Select Payment Mode</option>
                          <option value="UPI/QR Code">UPI/QR Code</option>
                          <option value="NEFT/IMPS/RTGS">NEFT/IMPS/RTGS</option>
                          <option value="Cash/Bank Deposit">Cash/Bank Deposit</option>
                          <option value="Credit">Credit</option>
                          <option value="Credit Card">Credit Card</option>
                        </select>

                        <label className="sales-form-label">Amount (₹):  </label>
                        <input
                          type="text"
                          name="Amount"
                          value={formData.Amount}
                          onChange={handleChange}
                          className="sales-form-input" />
                        
                        {/* Display the amount in text */}
                        {amountText && (
                          <div className="amount-text">
                            <strong>In Words:</strong> {amountText}
                          </div>
                        )}
                        <label className="sales-form-label">Transaction ID:  </label>
                        <input
                          type="text"
                          name="Transaction_ID"
                          value={formData.Transaction_ID}
                          onChange={handleChange}
                          className="sales-form-input" />
                        {/* Add more payment fields as needed */}
                        <label className="sales-form-label">Pick-Up Location:</label>
                        <select
                        name="PickUpLocationType"
                        value={formData.PickUpLocationType}
                        onChange={handlePickUpLocationChange}
                        className="sales-form-input"
                        >
                          <option value="">Select Pick-Up Location</option>
                          <option value="hospital">Same as Hospital Location</option>
                          <option value="phlebotomist">Phlebotomist Location</option>
                        </select>

                        {formData.PickUpLocationType === "phlebotomist" && (
                        <>
                        <label className="sales-form-label">Phlebotomist:</label>
                        <select
                        name="Phelobotomist"
                        value={formData.Phelobotomist}
                        onChange={handlePhlebotomistSelect}
                        className="sales-form-input"
                        >
                          <option value="">Select Phlebotomist</option>
                          {phlebotomists.map((p) => (
                            <option key={p.id} value={p.id}>
                              {p.name}{p.city ? ` — ${p.city}` : ""}
                            </option>
                          ))}
                        </select>
                        </>
                        )}

                        {formData.PickUpLocationType && (
                        <>
                        <label className="sales-form-label">Pick-Up City:</label>
                        <input
                        type="text"
                        name="PickUpCity"
                        value={formData.PickUpCity}
                        onChange={handleChange}
                        className="sales-form-input"
                        />
                        <label className="sales-form-label">Pick-Up Address:</label>
                        <input
                        type="text"
                        name="PickUpAdress"
                        value={formData.PickUpAdress}
                        onChange={handleChange}
                        className="sales-form-input"
                        />
                        <label className="sales-form-label"> Pick-Up City PinCode:</label>
                        <input
                        type="text"
                        name="PickUpCityPinCode"
                        value={formData.PickUpCityPinCode}
                        onChange={handleChange}
                        className="sales-form-input"
                        />
                        </>
                        )}
                         <label className="sales-form-label">Contact Person Name:</label>
                        <input
                        type="text"
                        name="ContactPersonName"
                        value={formData.ContactPersonName}
                        onChange={handleChange}
                        className="sales-form-input"
                        />
                        <label className="sales-form-label">Contact Person Number:</label>
                        <input
                        type="number"
                        name="ContactPersonNumber"
                        value={formData.ContactPersonNumber}
                        onChange={handleChange}
                        className="sales-form-input"
                        />
                        <label className="sales-form-label">Pick-Up date:</label>
                        <input
                        type="date"
                        name="PickUpdate"
                        value={formData.PickUpdate}
                        onChange={handleChange}
                        className="sales-form-input"
                        />
                        <hr></hr>
                      <p>
                      
                      <img 
                        style={{ width: '100%', maxWidth: '500px', height: 'auto' }} 
                        src="https://crm-zeniximages.s3.ap-south-1.amazonaws.com/ZeiniX+Payment+Options+(1).jpg" 
                        alt="Payment Options"
                      />
                      </p>
                      </div>
                    </>
                  )}

                  <div style={{ marginTop: "50px" }}>

                    {formData.currentStep > 1 && formData.currentStep < 6 && (
                      <button
                        type="button"
                        onClick={handleBack}
                        className="sales-form-button-back"
                      >
                        Back
                      </button>
                    )}
                    {formData.currentStep < 5 && (
                      <button
                        type="button"
                        onClick={handleNext}
                        className="sales-form-button-Next"
                      >
                        Next
                      </button>
                    )}


                    {/* Render Submit button for the last step */}
                    {formData.currentStep === 5 && (
                      <button type="button" className="sales-form-button-Submit" onClick={handleNext}>
                        Preview
                      </button>
                    )}
                    {formData.currentStep === 6 && (
                      <>
                        <div style={{ backgroundColor: "blue", marginTop: "115px" }}>
                          <h2 style={{ marginTop: "0px", justifyItems: "center" }}>
                            Preview Form
                          </h2>
                        </div>
                        <div>
                          <PreviewForm formData={formData} handleBack={handleBack} />

                          <label style={{ display: "block", margin: "15px 0" }}>
                              <input 
                              type="checkbox" 
                              checked={isChecked} 
                              onChange={(e) => setIsChecked(e.target.checked)} 
                              />
                            { ` I hereby grant my informed consent to ZeiniX Life Sciences Pvt. Ltd., Bangalore, to facilitate the diagnostic testing of the biological sample of patient ${formData.PatientFullName} at Amrita Institute of Medical Sciences, Cochin, for the purpose of medical evaluation.`}
                            </label>
                            
                            <button type="submit" onClick={handleSubmit} className="sales-form-button-Submit" disabled={loading||!isChecked}  style={{ cursor: loading||! isChecked ? 'not-allowed' : 'pointer', opacity: loading || !isChecked ? 0.2 : 1 }}>
                          {loading ? 'Submitting...' : 'Submit'}
                          </button>
                        </div>
                      </>
                    )}


                  </div>
                </form>


              </div>
            </>

          )}

          <AddHospitalCityModal
          show={showAddCityModal}
          onClose={()=>setShowAddCityModal(false)}
          onSave={(hospitalCity)=>{
            axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/cities`,{name:hospitalCity})
            .then(response=>{
              setCities([...cities,response.data]);
              setFormData((prevState)=>({
                ...prevState,
                City:response.data.name
              }));
              toast.success("Hospital City added successfully!");
                alert("Hospital City added successfully!")
            })
            .catch(error => {
              alert("Failed to add Hospital City,Please retry or Contact support@zeinixlife.com")
              console.error("Failed to add hospital City:", error);
              toast.error("Failed to add hospital City");
            });

          }}
          />
        <AddHospitalModal
          show={showAddHospitalModal}
          onClose={() => setShowAddHospitalModal(false)}
          onSave={(hospitalName, cityId, optionalFields) => {
            // Logic to save the new hospital with new optional fields
            const payload = { 
              hospitalName, 
              city_id: selectedCityId,
              ...optionalFields
            };
            axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/hospitals`, payload)
              .then(response => {
                // Update hospitals list
                setHospitals([...hospitals, response.data]);
                
                setFormData((prevState) => ({
                  ...prevState,
                  HospitalClinicName: response.data.hospitalName
                }));
                // toast.success("Hospital added successfully!");
                alert("Hospital added successfully!")
              })
              .catch(error => {
                alert("Failed to add Hospital,Please retry or Contact support@zeinixlife.com")
                console.error("Failed to add hospital:", error);
                toast.error("Failed to add hospital");
              });
          } }
          cityId={selectedCityId} />
        <AddDoctorModal
        
          show={showAddDoctorModal}
          onClose={() => setShowAddDoctorModal(false)}
         
          onSave={(doctorName,selectedHospitalId, mobileNumber, email) => {
            console.log("doctorName",doctorName,"selectedHospitalId",selectedHospitalId,"mobileNumber",mobileNumber,"email",email)
            // Logic to save the new doctor
            axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/doctors`, { doctorName, hospital_id: selectedHospitalId, mobile_number: mobileNumber, email })
              .then(response => {
                // Update doctors list
                setDoctors([...doctors, response.data]);
                setFormData((prevState) => ({
                  ...prevState,
                  ReferringConsultantName_PrimaryPhysician: response.data.doctorName
                }));
                alert("Doctor added successfully!")
                toast.success("Doctor added successfully!");
                setShowAddDoctorModal(false)
                
              })
              .catch(error => {
                alert("Failed to add doctor,Please retry or Contact support@zeinixlife.com")
                console.error("Failed to add doctor:", error);
                toast.error("Failed to add doctor");
              });
          } }
          hospitalId={selectedHospitalId} />
        <FloatingHelpButton onHelpClick={() => setShowHelpModal(true)} />
        {showHelpModal && <HelpModal onClose={() => setShowHelpModal(false)} />}

      </div>
      <Footer />

      <CongratulationModal
        show={showCongratsModal}
        onClose={() => {setShowCongratsModal(false); 
                        resetForm();
                        setShowInstructions(true);
                        setIsAgreed(false);}}
      />
    </>
  );
};

const Footer = () => {
  return (
    <div className="footer">
      <p style={{ margin: "0px" }}>Powered by ZeiniX</p>
    </div>
  );
};
export default SalesEntryForm;
